import closeModal from './CloseModal';
import closeSmallModal from './CloseSmallModal';
import refreshLeads from './RefreshLeads';
import store from '../store';

const finishAcceptLead = () => (
  () => {
    store.dispatch(refreshLeads());
    store.dispatch(closeModal());
    store.dispatch(closeSmallModal());
  }
);

export default finishAcceptLead;
